export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/mounted.js